export default "__VITE_ASSET__DjedMpBH__"